const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoNet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M464.497,113.473c-1.584-2.687-3.246-5.323-4.987-7.903 c-23.183-34.346-63.071-57.838-102.312-68.458c-17.184-4.651-34.93-7.089-52.711-7.692 c-116.614-3.953-163.062,87.955-201.604,111.673S5.045,205.329,8.998,290.319S74.223,455.358,192.814,460.3 c118.591,4.941,126.497-48.424,192.71-68.19c43.819-13.08,74.952-57.26,90.197-98.088 C496.496,238.38,495.517,166.106,464.497,113.473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M464.497,113.473c-1.584-2.687-3.246-5.323-4.987-7.903 c-23.183-34.346-63.071-57.838-102.312-68.458c-17.184-4.651-34.93-7.089-52.711-7.692 c-116.614-3.953-163.062,87.955-201.604,111.673S5.045,205.329,8.998,290.319S74.223,455.358,192.814,460.3 c118.591,4.941,126.497-48.424,192.71-68.19c43.819-13.08,74.952-57.26,90.197-98.088 C496.496,238.38,495.517,166.106,464.497,113.473z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Window"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "438.561,121.493 438.561,118.197 377.696,118.197  377.696,69.417 375.718,69.417 375.718,118.197 315.293,118.197 315.293,121.493 375.718,121.493 375.718,166.652  315.293,166.652 315.293,169.948 375.718,169.948 375.718,215.107 315.293,215.107 315.293,218.403 375.718,218.403  375.718,265.854 377.696,265.854 377.696,218.403 438.561,218.403 438.561,215.107 377.696,215.107 377.696,169.948  438.561,169.948 438.561,166.652 377.696,166.652 377.696,121.493  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M311.118,65.462v205.666h131.178V65.462H311.118z  M437.868,264.185H315.547V72.405h122.321V264.185z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M253.995,323.918l0.002-0.006c0.02-0.05-0.004-0.107-0.054-0.128 c-0.051-0.022-0.11,0.001-0.132,0.052c-3.031,6.999-5.161,14.346-6.941,21.757c-1.717,7.431-2.96,14.97-3.829,22.556 l-0.543,5.701c-0.084,0.951-0.187,1.901-0.255,2.853l-0.156,2.86c-0.082,1.908-0.199,3.816-0.253,5.725l0.052,5.73l0.064,2.863 c0.042,0.954,0.111,1.906,0.176,2.859c0.144,1.904,0.261,3.809,0.435,5.709c0.365,3.798,0.936,7.576,1.524,11.338 c0.007,0.048,0.049,0.085,0.1,0.085c0.055,0,0.1-0.045,0.1-0.101v-0.005c-0.01-1.91-0.091-3.809-0.133-5.71 c-0.055-1.899-0.22-3.789-0.194-5.689c0.009-1.899-0.041-3.793-0.062-5.687l-0.053-2.84l0.051-2.84l0.026-5.677l0.154-5.674 l0.059-2.839c0.036-0.946,0.107-1.889,0.159-2.835l0.349-5.671c0.664-7.546,1.701-15.065,3.212-22.497 C249.359,338.383,251.225,330.987,253.995,323.918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M254.808,353.604c0.014-0.051-0.012-0.108-0.063-0.125c-0.052-0.018-0.11,0.01-0.128,0.062 c-1.634,4.717-2.938,9.542-4.041,14.418c-1.054,4.884-1.881,9.833-2.386,14.819c-0.504,4.968-1.06,9.942-1.128,14.937 c-0.077,4.993,0.003,9.992,0.531,14.98c0.005,0.046,0.042,0.085,0.09,0.09c0.056,0.006,0.105-0.034,0.111-0.09 c0.577-4.973,0.929-9.935,1.273-14.894c0.352-4.957,0.4-9.929,0.723-14.888c0.3-4.944,0.92-9.868,1.771-14.76 C252.395,363.259,253.435,358.385,254.808,353.604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M271.266,364.047c-0.03-0.047-0.092-0.061-0.138-0.031c-4.12,2.608-7.794,5.893-11.005,9.594 c-1.578,1.878-3.045,3.845-4.303,5.983l-0.884,1.669l-0.692,1.734c-0.249,0.575-0.424,1.167-0.604,1.758 c-0.178,0.591-0.377,1.18-0.536,1.776c-1.236,4.77-2.055,9.63-2.277,14.517c-0.199,4.883-0.106,9.773,0.546,14.622 c0.007,0.046,0.045,0.084,0.093,0.087c0.055,0.004,0.104-0.038,0.108-0.093l1.254-14.474c0.5-4.785,0.806-9.598,1.833-14.271 c0.131-0.582,0.298-1.151,0.445-1.728c0.149-0.576,0.294-1.156,0.508-1.704l0.588-1.673l0.756-1.58 c1.115-2.091,2.478-4.091,3.943-5.987c2.939-3.793,6.397-7.25,10.333-10.057l0.006-0.004 C271.283,364.152,271.295,364.092,271.266,364.047z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M263.301,382.643c-2.243,1.448-3.743,3.725-5.004,6.016c-1.202,2.342-2.149,4.824-2.804,7.37 c-0.197,0.631-0.352,1.269-0.489,1.912l-0.454,1.924c-0.231,1.292-0.413,2.599-0.486,3.909c-0.017,1.313-0.055,2.625,0.034,3.934 c0.109,1.309,0.258,2.614,0.516,3.909c0.009,0.037,0.04,0.072,0.08,0.08c0.055,0.011,0.109-0.025,0.12-0.08 c0.317-1.291,0.525-2.571,0.693-3.848c0.203-1.274,0.402-2.54,0.554-3.807c0.186-1.262,0.353-2.52,0.451-3.792 c0.176-1.254,0.269-2.537,0.544-3.776c0.44-2.509,1.166-4.959,2.146-7.301c0.976-2.323,2.247-4.638,4.202-6.275l0.015-0.013 c0.038-0.032,0.047-0.088,0.02-0.13C263.409,382.626,263.347,382.613,263.301,382.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M240.22,397.141c-0.541-6.425-1.601-12.786-2.603-19.145c-1.005-6.359-2.112-12.698-3.276-19.026 c-1.204-6.321-2.464-12.629-3.826-18.915c-0.012-0.052-0.063-0.087-0.116-0.078c-0.055,0.01-0.091,0.062-0.081,0.117 c1.1,6.334,2.095,12.686,3.034,19.043c0.964,6.353,1.872,12.714,2.676,19.086c0.785,6.375,1.397,12.765,2.196,19.128l2.35,19.127 c0.006,0.048,0.045,0.087,0.095,0.089c0.055,0.003,0.102-0.04,0.105-0.096c0.073-1.612,0.075-3.223,0.115-4.839 c0.014-1.615-0.066-3.223-0.094-4.837C240.736,403.567,240.461,400.356,240.22,397.141z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M236.367,397.048c-0.344-2.545-0.811-5.075-1.297-7.597l-0.902-3.751 c-0.295-1.251-0.576-2.504-0.942-3.739c-1.282-4.977-2.921-9.87-4.911-14.611l-0.77-1.768l-0.856-1.73 c-0.544-1.165-1.203-2.274-1.828-3.397c-1.343-2.188-2.738-4.375-4.638-6.149c-0.039-0.036-0.099-0.036-0.138,0.001 c-0.04,0.038-0.041,0.102-0.003,0.141l0.01,0.01c1.756,1.82,3.036,4.068,4.242,6.289c0.559,1.143,1.149,2.266,1.627,3.445 l0.755,1.749l0.669,1.785c1.78,4.757,3.208,9.646,4.282,14.616c0.585,2.472,0.974,4.992,1.452,7.484l0.602,3.766 c0.218,1.252,0.486,2.495,0.662,3.755c0.401,2.512,0.863,5.017,1.302,7.531c0.389,2.52,0.85,5.036,1.381,7.555 c0.01,0.045,0.051,0.083,0.099,0.083c0.056,0,0.101-0.045,0.101-0.1c0.011-2.567-0.048-5.136-0.179-7.7 C236.937,402.154,236.634,399.603,236.367,397.048z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M231.049,397.376c-1.191-3.371-2.568-6.671-4.069-9.907c-1.54-3.218-3.203-6.375-5.117-9.382 c-0.03-0.042-0.09-0.059-0.136-0.033c-0.048,0.028-0.064,0.09-0.035,0.138c1.672,3.123,3.086,6.381,4.368,9.675 c1.304,3.286,2.48,6.621,3.465,10.009c1.005,3.384,1.724,6.834,2.625,10.233c0.947,3.397,1.712,6.829,2.757,10.269 c0.013,0.041,0.051,0.074,0.096,0.075c0.056,0.001,0.102-0.044,0.103-0.1c0.051-3.589-0.302-7.176-1-10.689 C233.476,404.128,232.233,400.745,231.049,397.376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M230.829,408.605c-0.609-2.111-1.648-4.078-2.828-5.931c-1.159-1.863-2.504-3.624-4.117-5.116 c-0.83-0.719-1.68-1.412-2.619-1.975c-0.925-0.578-1.906-1.066-2.97-1.343c-0.046-0.012-0.096,0.011-0.116,0.056 c-0.022,0.05,0,0.109,0.051,0.132l0.012,0.005c1.925,0.856,3.552,2.275,4.927,3.827c1.394,1.555,2.506,3.339,3.433,5.198 c0.975,1.846,1.479,3.886,2.327,5.787c0.374,0.975,0.746,1.956,1.178,2.929c0.367,0.993,0.774,1.984,1.292,2.969l0.003,0.005 c0.016,0.031,0.049,0.053,0.087,0.055c0.057,0.002,0.105-0.042,0.107-0.099c0.046-1.099-0.018-2.193-0.123-3.284 C231.315,410.742,231.087,409.671,230.829,408.605z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M231.226,349.253c0,0-10.529-2.43-12.958-13.768c-2.43-11.339,5.399-6.479-1.62-24.297 c-7.019-17.818-5.399-21.867-2.97-26.996c2.43-5.13,3.78-3.51,5.939,3.24c2.16,6.749,9.989,17.278,12.958,36.985 S231.226,349.253,231.226,349.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M252.014,330.086c0,0-7.019-2.43-7.289-15.658c-0.27-13.228,5.129-10.529,5.939-26.997 c0.81-16.468,1.89-28.076,4.859-28.346c2.97-0.27,10.799,8.099,13.498,26.457c2.7,18.358-3.51,30.506-8.909,35.905 C254.713,326.846,252.014,330.086,252.014,330.086z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M227.447,365.181c0,0-1.62-9.719-4.859-14.308c-3.24-4.589-10.259-8.639-14.848-17.548 c-4.589-8.909-9.719-13.228-9.449-0.54c0.27,12.688,5.939,19.168,12.958,23.487C218.268,360.592,227.447,365.181,227.447,365.181z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M224.477,381.919c0,0-6.479-12.418-15.928-21.597c-9.449-9.179-17.008-13.768-14.308-9.179 c2.7,4.589,5.939,4.319,10.529,12.418c4.589,8.099,3.24,14.038,9.719,18.628C220.968,386.779,224.477,381.919,224.477,381.919z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M223.667,397.847c-0.27-0.81-0.54-6.749-9.719-11.609c-9.179-4.859-17.818-2.97-16.738-0.54 c1.08,2.43,6.749,6.479,12.418,8.909C215.298,397.037,223.667,397.847,223.667,397.847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M251.474,365.721c0,0-4.049-5.129-1.89-15.928c2.16-10.799,7.019-8.099,12.418-13.768 c5.399-5.669,4.319-6.479,9.719-12.418c5.399-5.939,10.259-9.179,12.418-6.749c2.16,2.43-1.08,9.989-4.319,14.308 c-3.24,4.32-8.369,6.479-10.799,11.879c-2.43,5.399-1.35,14.038-7.559,18.088C255.253,365.181,251.474,365.721,251.474,365.721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M264.972,368.691c0,0,9.719-11.068,16.738-19.168c7.019-8.099,9.719-14.308,9.989-8.909 c0.27,5.399,2.43,9.719-3.24,16.738C282.79,364.371,264.972,368.691,264.972,368.691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M259.843,386.509c0,0-0.27-4.319,15.118-14.308c15.388-9.989,21.867-11.878,20.247-7.829 c-1.62,4.049-8.369,8.099-15.658,15.388C272.261,387.049,259.843,386.509,259.843,386.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M231.868,348.103 c0,0-3.612-19.367-7.391-33.135c-3.78-13.768-6.209-22.137-6.209-22.137"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M251.392,330.289 c0,0,6.561-20.991,8.721-33.68c2.16-12.688-0.27-22.137-1.35-27.806"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M226.596,364.776 c0,0-4.008-7.154-9.948-14.173c-5.939-7.019-10.529-10.798-13.228-17.548"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M251.474,365.721 c0,0,2.16-12.958,7.289-19.707c5.129-6.749,15.388-17.278,19.438-24.027"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M223.033,397.552 c0,0-9.085-5.914-15.564-9.154"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 252.891,454.81 234.128,454.81 224.747,407.836 262.272,407.836  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Floor_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 64.803,
    y1: 454.81,
    x2: 489.977,
    y2: 454.81
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 31.184,
    y1: 454.81,
    x2: 57.552,
    y2: 454.81
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M216.143,167.01v-31.499h-2.849 V95.186c0-13.728-11.129-24.857-24.857-24.857H54.92c-13.728,0-24.857,11.129-24.857,24.857v317.433 c0,13.728,11.129,24.857,24.857,24.857h133.517c13.728,0,24.857-11.129,24.857-24.857V193.855h2.849v-18.613h-2.849v-8.233 H216.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M184.082,434.052H59.275 c-14.544,0-26.334-11.79-26.334-26.334V100.087c0-14.544,7.454-26.334,26.334-26.334h124.807 c17.307-0.237,26.334,11.79,26.334,26.334v307.631C210.416,422.262,198.626,434.052,184.082,434.052z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M131.335,77.803l-0.05,0.185 c-1.458,5.438-4.818,8.967-8.537,8.967h-2.14c-3.719,0-7.079-3.529-8.537-8.967l-0.049-0.185l-52.081-0.182 C47.811,77.578,37.953,87.399,37.95,99.53L37.875,404.47c0,14.211,11.129,25.732,24.857,25.732h117.893 c13.728,0,24.857-11.521,24.857-25.732l-0.026-307.134c-0.001-10.401-8.377-18.862-18.777-18.968L131.335,77.803z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBDBDB",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M205.457,102.882l-0.001-5.545 c-0.001-10.401-8.377-18.862-18.777-18.968l-55.344-0.566l-0.05,0.185c-1.458,5.438-4.818,8.967-8.537,8.967h-2.14 c-3.719,0-7.079-3.529-8.537-8.967l-0.049-0.185l-52.081-0.182C47.811,77.578,37.953,87.398,37.95,99.53l-0.001,3.352H205.457 z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#707070"
    },
    d: "M123.5,77.202c0-1.289-1.045-2.334-2.334-2.334c-1.289,0-2.334,1.045-2.334,2.334 c0,1.289,1.045,2.334,2.334,2.334C122.456,79.535,123.5,78.49,123.5,77.202z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M54.399,83.144c0,2.361-2.652,3.211-2.663,5.013v0.123h2.573v0.795h-3.434v-0.672 c0-2.528,2.652-3.021,2.652-5.225c0-0.805-0.269-1.23-0.918-1.23c-0.638,0-0.918,0.458-0.918,1.152v0.694h-0.816v-0.638 c0-1.197,0.548-1.992,1.756-1.992C53.851,81.164,54.399,81.947,54.399,83.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M58.685,83.133v0.201c0,0.806-0.324,1.377-0.951,1.611c0.66,0.246,0.951,0.839,0.951,1.622 v0.604c0,1.197-0.559,1.98-1.768,1.98c-1.197,0-1.756-0.783-1.756-1.98v-0.537h0.816v0.593c0,0.705,0.291,1.13,0.918,1.13 c0.638,0,0.918-0.414,0.918-1.208v-0.604c0-0.772-0.325-1.141-0.985-1.163h-0.47v-0.784h0.514 c0.582-0.022,0.94-0.391,0.94-1.074v-0.359c0-0.805-0.28-1.219-0.918-1.219c-0.627,0-0.918,0.436-0.918,1.141v0.403h-0.816 v-0.358c0-1.197,0.559-1.97,1.756-1.97C58.126,81.164,58.685,81.936,58.685,83.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M60.376,83.726v1.086h-0.839v-1.086H60.376z M60.376,87.989v1.086h-0.839v-1.086H60.376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M62.144,84.431c0.246-0.425,0.638-0.649,1.164-0.649c1.007,0,1.454,0.738,1.454,1.857v1.533 c0,1.197-0.57,1.98-1.767,1.98c-1.198,0-1.757-0.783-1.757-1.98v-0.526h0.816v0.581c0,0.705,0.291,1.13,0.918,1.13 c0.627,0,0.918-0.425,0.918-1.13v-1.521c0-0.705-0.291-1.13-0.918-1.13c-0.481,0-0.806,0.269-0.884,0.839v0.179h-0.816 l0.213-4.352h3.088v0.783h-2.305L62.144,84.431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M69.116,83.122v0.146H68.3v-0.201c0-0.705-0.291-1.119-0.929-1.119 c-0.66,0-0.951,0.425-0.951,1.264v1.756c0.212-0.537,0.638-0.839,1.264-0.839c1.007,0,1.455,0.728,1.455,1.857v1.186 c0,1.197-0.594,1.98-1.791,1.98c-1.208,0-1.801-0.783-1.801-1.98v-3.995c0-1.242,0.56-2.014,1.801-2.014 C68.557,81.164,69.116,81.925,69.116,83.122z M66.42,86.053v1.174c0,0.705,0.291,1.13,0.928,1.13 c0.627,0,0.929-0.425,0.929-1.13v-1.174c0-0.705-0.302-1.13-0.929-1.13C66.711,84.923,66.42,85.348,66.42,86.053z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 152.408,
    y: 83.466,
    style: {
      fill: "#263238"
    },
    width: 2.211,
    height: 5.529
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.356,
    y: 82.359,
    style: {
      fill: "#263238"
    },
    width: 2.211,
    height: 6.636
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.305,
    y: 81.572,
    style: {
      fill: "#263238"
    },
    width: 2.211,
    height: 7.423
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.253,
    y: 80.205,
    style: {
      fill: "#263238"
    },
    width: 2.211,
    height: 8.79
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M190.831,88.843h-13.269v-8.108h13.269V88.843z M178.3,88.106h11.794v-6.634H178.3V88.106z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 179.406,
    y: 82.274,
    style: {
      fill: "#263238"
    },
    width: 7.003,
    height: 5.03
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 190.371,
    y: 83.834,
    style: {
      fill: "#263238"
    },
    width: 1.669,
    height: 1.91
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M172.698,87.079c-0.086,0-0.174-0.022-0.253-0.07c-2.7-1.605-4.485-0.115-4.56-0.052 c-0.206,0.179-0.519,0.156-0.698-0.049c-0.179-0.206-0.16-0.516,0.046-0.696c0.096-0.084,2.378-2.039,5.719-0.054 c0.235,0.139,0.313,0.444,0.172,0.679C173.031,86.993,172.866,87.079,172.698,87.079z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M173.697,85.413c-0.086,0-0.174-0.022-0.254-0.07c-3.904-2.322-6.528-0.076-6.555-0.054 c-0.205,0.182-0.518,0.161-0.699-0.044c-0.181-0.205-0.162-0.519,0.044-0.699c0.032-0.029,3.197-2.74,7.717-0.054 c0.235,0.139,0.313,0.444,0.172,0.68C174.029,85.327,173.865,85.413,173.697,85.413z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M174.603,83.484c-0.086,0-0.174-0.022-0.254-0.07c-4.945-2.94-8.232-0.172-8.37-0.052 c-0.206,0.179-0.52,0.157-0.699-0.048c-0.18-0.205-0.16-0.517,0.046-0.697c0.039-0.035,3.945-3.376,9.53-0.054 c0.235,0.139,0.313,0.444,0.172,0.679C174.936,83.398,174.772,83.484,174.603,83.484z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M171.206,87.91c0,0.687-0.557,1.243-1.243,1.243c-0.687,0-1.243-0.557-1.243-1.243 c0-0.687,0.557-1.243,1.243-1.243C170.649,86.666,171.206,87.223,171.206,87.91z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M121.532,217.659c21.986,0.341,40.333,8.681,54.78,25.363c1.973,2.278,1.732,5.439-0.47,7.329 c-2.099,1.803-5.22,1.574-7.15-0.667c-5.252-6.098-11.341-11.147-18.476-14.892c-22.371-11.74-49.129-8.862-68.401,7.443 c-2.656,2.247-5.02,4.853-7.414,7.392c-2.074,2.199-5.134,2.551-7.326,0.662c-2.165-1.865-2.329-5.042-0.354-7.331 c12.108-14.033,27.342-22.328,45.703-24.865c1.438-0.199,2.888-0.353,4.337-0.419 C118.349,217.604,119.942,217.659,121.532,217.659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M123.348,238.045c13.897,0.36,26.961,6.296,37.242,18.176c2.028,2.343,1.79,5.367-0.46,7.301 c-2.143,1.841-5.245,1.593-7.224-0.698c-5.364-6.21-11.866-10.764-19.793-12.904c-16.154-4.361-30.121-0.384-41.817,11.573 c-0.435,0.445-0.837,0.922-1.25,1.388c-1.93,2.174-5.053,2.466-7.163,0.668c-2.225-1.896-2.456-5.029-0.51-7.323 c4.581-5.4,10.035-9.694,16.381-12.843C105.945,239.814,113.567,238.078,123.348,238.045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M146.212,272.813c-0.002,2.116-1.281,3.988-3.248,4.755c-1.98,0.772-4.18,0.258-5.663-1.421 c-2.185-2.475-4.705-4.476-7.761-5.771c-8.343-3.535-17.547-1.339-23.751,5.669c-1.472,1.662-3.308,2.265-5.431,1.621 c-2.042-0.619-3.22-2.09-3.535-4.197c-0.222-1.484,0.225-2.802,1.18-3.953c10.626-12.813,30.175-14.627,42.959-3.945 c1.453,1.214,2.817,2.572,4.019,4.031c0.707,0.858,1.012,2.047,1.498,3.087C146.39,272.73,146.301,272.772,146.212,272.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M121.515,299.505c-5.701,0.003-10.228-4.52-10.224-10.215 c0.003-5.605,4.558-10.161,10.179-10.183c5.647-0.022,10.23,4.573,10.215,10.242 C131.671,294.993,127.156,299.502,121.515,299.505z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M121.578,182.037c-40.096,0-72.716,32.62-72.716,72.715c0,40.096,32.62,72.716,72.716,72.716 c40.095,0,72.715-32.62,72.715-72.716C194.294,214.657,161.674,182.037,121.578,182.037z M58.863,254.752 c0-34.582,28.134-62.715,62.716-62.715c16.322,0,31.203,6.272,42.372,16.527L75.39,297.125 C65.135,285.956,58.863,271.075,58.863,254.752z M121.578,317.468c-14.665,0-28.159-5.073-38.852-13.538l88.029-88.029 c8.465,10.692,13.538,24.186,13.538,38.851C184.294,289.334,156.16,317.468,121.578,317.468z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Couch"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "427.499,454.81 418.024,454.81 415.994,432.251  429.529,432.251  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "466.977,454.81 457.502,454.81 455.472,432.251  469.007,432.251  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "372.23,454.81 362.755,454.81 360.725,432.251  374.26,432.251  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "329.932,454.81 320.457,454.81 318.427,432.251  331.962,432.251  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M375.171,286.9h98.519c0,0,0.393,34.249-4.683,58.5 c-5.076,24.251-11.279,38.914-11.279,38.914h-93.619C364.109,384.314,377.997,330.674,375.171,286.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M416.056,292.128c-8.636-0.675-12.061-2.418-18.53-5.96c-8.408-4.604-10.209-1.535-9.609,3.069 c0.601,4.604-8.17,34.961-9.972,50.306s-1.201,23.529-1.201,23.529s-5.405,4.604-1.802,6.138 c3.603,1.535,7.207,2.046,7.207,2.046h69.665c0,0,12.374-63.605,13.575-73.835c1.201-10.23-4.204-11.253-7.207-9.719 c-3.003,1.535-3.603,2.558-7.809,3.069C440.501,291.973,427.897,293.054,416.056,292.128z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M393.631,293.161c2.116-2.484,3.172-4.835,3.686-7.101c-0.839-0.452-1.607-0.822-2.316-1.125 c-0.395,2.135-1.296,4.305-3.262,6.614c-1.492,1.752-3.003,2.883-4.539,3.647c-0.176,0.917-0.377,1.905-0.602,2.964 C388.957,297.321,391.316,295.879,393.631,293.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M455.993,313.058c-4.413,5.181-4.243,9.785-4.078,14.237c0.154,4.16,0.298,8.089-3.487,12.534 c-3.785,4.444-7.686,4.926-11.818,5.436c-4.421,0.546-8.993,1.111-13.404,6.291c-4.412,5.181-4.242,9.784-4.077,14.236 c0.068,1.845,0.133,3.645-0.145,5.464h2.515c0.243-1.896,0.18-3.739,0.113-5.555c-0.153-4.16-0.299-8.089,3.486-12.533 c3.785-4.444,7.686-4.926,11.818-5.436c4.421-0.546,8.993-1.111,13.404-6.291c4.412-5.181,4.242-9.784,4.078-14.237 c-0.153-4.16-0.298-8.09,3.487-12.534c1.753-2.058,3.53-3.26,5.344-4.015c0.174-0.98,0.34-1.924,0.498-2.832 C461.136,308.621,458.538,310.07,455.993,313.058z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M385.234,370.135c4.421-0.546,8.993-1.111,13.404-6.291c4.412-5.18,4.242-9.784,4.077-14.235 c-0.153-4.16-0.299-8.089,3.486-12.533c3.785-4.444,7.686-4.926,11.818-5.436c4.421-0.546,8.993-1.111,13.405-6.291 c4.412-5.181,4.242-9.784,4.078-14.236c-0.153-4.16-0.298-8.09,3.487-12.535c3.785-4.445,7.687-4.927,11.819-5.438 c4.066-0.503,8.26-1.031,12.339-5.141c-0.839-0.629-1.8-0.878-2.738-0.853c-2.569,2.168-5.199,2.858-7.924,3.264 c-0.595,0.141-1.281,0.262-2.111,0.363c-0.971,0.118-1.975,0.234-2.996,0.348c-3.428,0.618-6.902,1.876-10.281,5.845 c-4.413,5.181-4.243,9.785-4.078,14.237c0.153,4.16,0.298,8.089-3.487,12.534c-3.785,4.444-7.686,4.926-11.818,5.436 c-4.421,0.546-8.993,1.111-13.405,6.291c-4.412,5.181-4.242,9.784-4.077,14.236c0.153,4.16,0.298,8.089-3.486,12.532 c-3.785,4.444-7.686,4.926-11.818,5.436c-2.759,0.341-5.577,0.69-8.378,2.163c1.526,0.537,2.947,0.897,3.977,1.12 C382.066,370.53,383.632,370.333,385.234,370.135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M379.742,347.75c4.411-5.18,4.241-9.784,4.077-14.235c-0.153-4.16-0.299-8.089,3.486-12.533 c3.785-4.444,7.686-4.926,11.818-5.437c4.421-0.546,8.993-1.111,13.405-6.291c4.412-5.181,4.242-9.784,4.078-14.236 c-0.035-0.961-0.068-1.91-0.054-2.856c-0.165-0.012-0.331-0.021-0.495-0.034c-0.699-0.055-1.354-0.119-1.989-0.188 c-0.02,1.068,0.017,2.123,0.055,3.169c0.153,4.16,0.298,8.089-3.487,12.534c-3.785,4.444-7.686,4.926-11.818,5.436 c-4.421,0.546-8.993,1.111-13.405,6.291c-4.412,5.181-4.242,9.784-4.077,14.236c0.153,4.16,0.298,8.089-3.486,12.533 c-0.211,0.248-0.423,0.48-0.635,0.704c-0.105,1.269-0.191,2.462-0.262,3.587C377.887,349.708,378.818,348.835,379.742,347.75z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M416.056,292.128c-8.636-0.675-12.061-2.418-18.53-5.96 c-8.408-4.604-10.209-1.535-9.609,3.069c0.601,4.604-8.17,34.961-9.972,50.306s-1.201,23.529-1.201,23.529 s-5.405,4.604-1.802,6.138c3.603,1.535,7.207,2.046,7.207,2.046h69.665c0,0,12.374-63.605,13.575-73.835 c1.201-10.23-4.204-11.253-7.207-9.719c-3.003,1.535-3.603,2.558-7.809,3.069C440.501,291.973,427.897,293.054,416.056,292.128z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M375.171,286.9h-5.574c-2.078,0-3.884,1.426-4.367,3.447 l-6.919,28.993c-1.283,5.376-5.659,20.884-10.48,23.588l0,0c-2.96,1.66-6.296,2.532-9.69,2.532h-20.887l8.889,90.768h37.959 l9.973-144.525c0.023-0.329,0.009-0.651-0.036-0.964h1.132V286.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M322.829,345.46h20.886c3.394,0,6.73-0.872,9.69-2.532l0,0 c4.821-2.704,9.197-18.212,10.48-23.588l6.919-28.993c0.482-2.021,2.289-3.447,4.367-3.447l0,0c2.604,0,4.661,2.208,4.478,4.805 l-10.251,144.525h-37.959L322.829,345.46z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "412.039,436.28 414.214,371.257 327.099,370.489  329.279,436.28  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M479.264,286.9h-5.574c-2.078,0-3.884,1.426-4.367,3.447 l-6.919,28.993c-1.283,5.376-5.659,20.884-10.48,23.588h0c-2.96,1.66-6.296,2.532-9.69,2.532h-20.887l3.684,90.768l42.816-0.001 l10.32-144.523c0.023-0.329,0.009-0.651-0.036-0.964h1.132V286.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M426.922,345.46h20.887c3.394,0,6.73-0.872,9.69-2.532l0,0 c4.821-2.704,9.197-18.212,10.48-23.588l6.919-28.993c0.482-2.021,2.289-3.447,4.367-3.447l0,0c2.604,0,4.661,2.208,4.478,4.805 l-10.164,142.312c-0.088,1.246-1.124,2.211-2.372,2.211l-40.878,0.001L426.922,345.46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M414.214,352.004l-2.175,84.276h18.289l3.138-84.276 c0-3.614-2.93-6.543-6.543-6.543h-6.165C417.144,345.46,414.214,348.39,414.214,352.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M307.942,352.004l3.138,84.276h18.289l-2.176-84.276 c0-3.614-2.93-6.543-6.543-6.543h-6.165C310.871,345.46,307.942,348.39,307.942,352.004z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 327.538,
    y1: 399.23,
    x2: 413.384,
    y2: 399.23
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M285.547,287.225c0,0-7.936,44.129-9.676,51.586 c-1.74,7.457-5.966,45.488-5.966,54.933c0,9.445,0.746,38.031,0.746,38.031s-3.231,1.491-3.231,2.734 c0,1.243,2.486,9.197,2.486,9.197l14.665,5.469c0,0,2.983-6.96,3.231-9.446c0.249-2.486-1.74-3.48-1.74-7.706 c0-4.226,7.457-53.442,9.694-61.645c2.237-8.203,8.7-32.811,9.943-35.048s7.457-18.642,7.457-18.642l3.48,1.74 c0,0,2.237,51.702,3.48,54.933c1.243,3.231,17.897,55.838,17.897,55.838s-2.734,1.243-0.994,4.226 c1.74,2.983,4.723,9.694,4.723,9.694s2.734-3.729,5.966-4.474c3.231-0.746,8.7,2.486,8.7,2.486s3.231-7.457,2.486-10.937 c-0.746-3.48-3.977-9.446-4.226-11.186c-0.249-1.74-6.96-51.861-6.96-51.861s1.74-70.096,1.74-74.819 c0-4.723-1.74-9.446-1.74-9.446s-14.665,5.469-32.314,6.214c-17.648,0.746-27.342-6.463-27.342-6.463L285.547,287.225z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M269.905,443.707c0,0-8.203,7.457-9.694,8.451 s-11.931,4.971-11.683,6.96c0.249,1.988,2.983,3.231,2.983,3.231h33.805c0,0,0.249-0.994,0.746-5.717 c0.497-4.723-1.491-8.948-1.491-8.948L269.905,443.707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M285.827,458.758l-37.115,1.025 c0.67,1.596,2.799,2.566,2.799,2.566h33.805C285.316,462.349,285.487,461.663,285.827,458.758z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M341.741,443.121c0,0-0.249,6.214-0.249,9.446 c0,3.231-0.497,6.96-0.249,7.706s0.746,1.988,0.746,1.988h19.637c0,0,0.746-1.988-0.249-5.717 c-0.994-3.729-2.734-5.717-3.231-8.948c-0.497-3.231-1.74-6.463-1.74-6.463S346.712,433.426,341.741,443.121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M361.889,459.909c-7.47-0.029-16.769-0.238-20.714-0.335 c0.003,0.319,0.023,0.56,0.069,0.697c0.249,0.746,0.746,1.988,0.746,1.988h19.637 C361.626,462.26,361.924,461.451,361.889,459.909z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M278.504,193.637c0,0-21.127,19.83-20.2,21.683 c0.927,1.853,6.672,16.865,6.672,16.865s1.668,10.008,0.741,16.309c-0.927,6.301-0.556,12.046-0.556,12.046 s2.965,3.892,7.042,6.116c4.077,2.224,7.228,6.116,9.822-0.185c2.595-6.301,1.483-17.606,1.483-17.606s3.521,13.714,4.077,16.123 c0.556,2.409-2.039,22.239-2.039,22.239s12.787,10.749,34.47,8.34c21.683-2.409,28.54-10.008,28.54-10.008 s-2.224-24.277-2.224-27.057c0-2.78-0.371-5.745-0.371-5.745s7.598,7.784,11.305,7.413c3.707-0.371,10.193-15.567,8.525-17.976 c-1.668-2.409-7.412-12.247-10.933-19.29c-3.521-7.042-5.278-13.196-5.278-13.196s-6.116-20.756-7.969-22.239 c-1.853-1.483-22.707-1.244-26.413-2.17c-3.706-0.927-13.529-2.039-14.826-2.039C299.075,183.258,282.581,187.15,278.504,193.637 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M340.801,221.394c-0.103-5.325-0.116-9.464-0.116-9.464"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M345.962,252.755c0,0-2.224-4.448-3.706-8.896 c-0.736-2.209-1.129-10.101-1.337-17.485"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M272.932,230.805c-1.896-3.303-3.335-5.883-3.508-6.404"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M283.508,248.863c0,0-4.737-7.982-8.72-14.844"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M307.6,185.853c0,0,1.297,9.822,0.185,19.644"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M320.073,277.317c2.228,0.455,4.616,0.859,7.171,1.198"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M293.145,265.357c0,0,5.965,6.587,21.967,10.805"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M309.453,279.441c0,0,9.081,4.633,21.868,4.448"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M265.161,163.614c0,0,2.224,10.378,2.409,12.602 c0.185,2.224,0.741,5.189,3.521,9.637c2.78,4.448,10.008,14.27,11.49,14.826c1.483,0.556,7.228-0.927,7.228-0.927 s6.116,12.046,7.784,11.675c1.668-0.371,5.93-14.085,6.486-19.644c0.556-5.56,0.185-8.34,0.185-8.34l-2.595-9.266 c0,0-2.224-12.973-2.224-13.899c0-0.927,1.297-7.598-5.93-10.378c-7.228-2.78-16.123-2.965-22.054,3.892 C265.532,160.649,265.161,163.614,265.161,163.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M284.991,151.939c0,0-3.151,5.374-10.008,9.822 s-3.521-0.371-3.521-0.371s-4.818,2.965-8.71,5.004c-3.892,2.039-2.409,2.594-3.892,2.039c-1.483-0.556-7.028-16.382,5.388-23.98 c12.417-7.598,21.428-5.611,21.428-5.611s-5.374-2.409-0.556-2.409c4.818,0,6.857,2.595,6.857,2.595s2.595-0.741,3.706,0.741 c0.345,0.46,1.01,0.851,1.763,1.171c5.976,2.54,8.098,8.223,9.227,14.15c0.741,3.892-2.409,13.158-2.409,13.158l-5.189,2.78 c0,0-2.224-2.039-2.965-4.077c-0.741-2.039-0.741-4.633-0.741-4.633s-3.151,4.077-3.707,1.112 c-0.556-2.965-2.039-10.564-2.039-10.564s0.556,2.965-1.297,2.965C286.473,155.83,284.991,151.939,284.991,151.939z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M298.705,172.324c0,0-0.185-6.301,3.521-8.34 c3.706-2.039,6.301,0.185,5.189,6.116c-1.112,5.93-7.784,8.154-7.784,8.154"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    points: "289.809,199.752 299.631,189.93 293.145,204.941  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M285.267,189.815c0.383,0.949,0.155,1.936-0.509,2.204s-1.514-0.284-1.897-1.233 c-0.383-0.949-0.155-1.936,0.509-2.204C284.035,188.314,284.884,188.866,285.267,189.815z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M287.828,172.663c0.362,1.173,0.106,2.293-0.572,2.503c-0.678,0.21-1.522-0.572-1.884-1.744 c-0.362-1.173-0.106-2.294,0.572-2.503C286.622,170.709,287.466,171.49,287.828,172.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M275.655,174.725c0.362,1.173,0.106,2.293-0.572,2.503c-0.678,0.209-1.522-0.572-1.884-1.744 c-0.362-1.173-0.106-2.293,0.572-2.503C274.449,172.771,275.293,173.552,275.655,174.725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M276.095,170.1c0,0,2.595,1.853,2.595,5.56 s-0.556,9.266-0.556,9.266l6.672-0.927"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M280.543,167.691c0,0,3.336-5.93,8.525-4.818"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M274.612,168.803c0,0-4.077-1.297-6.857,0.371"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M388.031,216.431c0,0,4.077-1.483,5.56-2.038 c1.483-0.556,2.965,0.371,5.56-0.927c2.595-1.297,5.56-3.892,5.745-2.038c0.185,1.853-0.741,2.594-2.224,3.521 c-1.483,0.927-3.892,2.78-3.892,2.78l-0.741,1.853l-11.119-0.927C386.919,218.655,387.104,216.987,388.031,216.431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M410.355,221.224c0,0,5.104-4.051,5.845-5.905 c0.741-1.853-0.556-2.039-1.853-1.297c-1.297,0.741-5.374,4.077-5.374,4.077L410.355,221.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M406.167,222.099c0,0,3.799,0.403,4.188-0.875 c0.389-1.279,3.378-9.341,2.88-10.352s-1.439-0.921-2.484,0.749c-1.045,1.67-2.902,7.069-2.902,7.069s-2.538,0.571-3.174,2.312 S406.167,222.099,406.167,222.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M401.374,223.103c0,0,3.521,1.483,4.263,0.371 c0.741-1.112,5.93-7.969,5.745-9.081c-0.185-1.112-1.112-1.297-2.595,0c-1.483,1.297-4.818,5.93-4.818,5.93 s-2.595-0.185-3.706,1.297C399.15,223.103,401.374,223.103,401.374,223.103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M349.669,253.496c0,0,1.483-8.525,10.378-14.27 c8.896-5.745,20.942-16.123,20.942-16.123s4.077-5.745,7.042-6.672c2.965-0.927,12.602,1.853,12.602,1.853 s7.784-7.784,7.969-6.116c0.185,1.668-3.707,7.598-5.56,9.822c-1.853,2.224-7.598,2.78-8.896,2.78 c-1.297,0-6.116,0.371-6.857,0.556s-12.973,16.865-18.532,25.019c-5.56,8.154-7.969,9.637-11.49,9.822 c-3.521,0.185-7.228-2.594-8.154-3.892C348.186,254.979,349.669,253.496,349.669,253.496z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M233.772,222.817l11.682,25.342 c0.352,0.762,1.175,1.189,2.001,1.037l9.693-1.79c1.155-0.213,1.815-1.44,1.357-2.521l-10.483-24.763 c-0.316-0.748-1.087-1.199-1.893-1.109l-10.893,1.21C233.991,220.362,233.247,221.68,233.772,222.817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M241.437,244.509c0,0-4.191-6.421-4.191-7.859 c0-1.437,2.441-4.853,3.878-7.933c1.437-3.08,1.642-5.133,2.874-4.722c1.232,0.411,1.027,1.643,0.616,3.696 c-0.411,2.053-2.669,7.802-2.669,7.802l0.411,2.464c0,0,1.848-3.696,3.696-5.544c1.848-1.848,3.901-4.928,5.338-4.312 c1.437,0.616,2.053,1.027,0.821,2.464c-1.232,1.437-2.095,2.631-4.138,5.911c-1.717,2.755-2.794,5.588-2.794,5.588 s2.313-2.23,4.366-3.667c2.053-1.437,4.825-3.52,6.057-2.699c1.232,0.821,1.437,1.643,0.205,2.669 c-1.232,1.027-2.349,1.735-3.992,3.173c-1.643,1.437-4.837,5.451-4.837,5.451s1.346-1.219,4.837-2.657 c3.49-1.437,6.68-1.273,6.811-0.175c0.117,0.982-3.667,2.096-3.667,2.096c-2.723,0.621-2.847,1.557-2.847,1.557 s2.258,4.517,1.848,5.954c0,0,9.124-1.424,12.615-2.451c3.49-1.027,8.931,1.001,10.587,2.656 c3.49,3.491,5.133,8.829,3.285,13.346c-1.848,4.517-1.848,3.08-16.426-1.027c-14.578-4.106-14.3-5.541-17.863-11.498 C244.907,252.537,241.437,244.509,241.437,244.509z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    x1: 254.059,
    y1: 253.767,
    x2: 253.748,
    y2: 257.53
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNet);
export default __webpack_public_path__ + "static/media/noNet.404a11c45b4d85b383fd1453f606686b.svg";
export { ForwardRef as ReactComponent };